import { AppBootstrap } from "./app/AppBootstrap";

export const App = () => {
  return <AppBootstrap />;
};
